export const SET_NAVBAR = "setNavbar";
